import { render, staticRenderFns } from "./UserUsageTraineeProgressTable.vue?vue&type=template&id=16296ffb&"
import script from "./UserUsageTraineeProgressTable.vue?vue&type=script&lang=ts&"
export * from "./UserUsageTraineeProgressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports